import React from "react";
import { useNavigate } from "react-router-dom";

function SecurityShowPage() {
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999999,
        overflowY: "auto",
        background:
          "radial-gradient(circle at top right, rgba(0,242,255,0.22), transparent 32%), radial-gradient(circle at bottom left, rgba(255,0,90,0.18), transparent 30%), #03070d",
        color: "#fff",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <style>
        {`
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(35px); }
            to { opacity: 1; transform: translateY(0); }
          }

          @keyframes glowPulse {
            0%, 100% { box-shadow: 0 0 25px rgba(0,242,255,0.25); }
            50% { box-shadow: 0 0 55px rgba(0,242,255,0.75); }
          }

          @keyframes liveWave {
            0% { transform: scale(1); opacity: 0.9; }
            100% { transform: scale(2.4); opacity: 0; }
          }

          @keyframes floatIcon {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }
        `}
      </style>

      <div
        style={{
          minHeight: "100vh",
          padding: "26px 18px 46px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        {/* 🔙 RETOUR */}
        <button
          onClick={goBack}
          style={{
            position: "fixed",
            top: 22,
            left: 22,
            zIndex: 10000000,
            padding: "11px 18px",
            borderRadius: 16,
            border: "1px solid rgba(0,242,255,0.45)",
            background: "rgba(0, 12, 20, 0.9)",
            color: "#00f2ff",
            fontWeight: 900,
            cursor: "pointer",
            boxShadow: "0 0 18px rgba(0,242,255,0.25)",
          }}
        >
          ← Retour
        </button>

        {/* ICON */}
        <div
          style={{
            marginTop: 70,
            width: 120,
            height: 120,
            borderRadius: "50%",
            border: "2px solid rgba(0,242,255,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            animation: "glowPulse 2.5s infinite",
          }}
        >
          <span
            style={{
              position: "absolute",
              width: 120,
              height: 120,
              borderRadius: "50%",
              border: "1px solid rgba(0,242,255,0.45)",
              animation: "liveWave 2s infinite",
            }}
          />

          <div style={{ fontSize: 52, animation: "floatIcon 2.6s ease-in-out infinite" }}>
            🛡️
          </div>
        </div>

        {/* TITRE */}
        <h1
          style={{
            marginTop: 34,
            marginBottom: 12,
            fontSize: 46,
            fontWeight: 900,
            letterSpacing: 1.5,
            color: "#fff",
            textShadow: "0 0 22px rgba(0,242,255,0.75)",
            animation: "fadeUp 0.7s ease forwards",
          }}
        >
          Sécurité renforcée
        </h1>

        {/* TEXTE */}
        <p
          style={{
            maxWidth: 840,
            color: "#9befff",
            fontSize: 20,
            lineHeight: 1.65,
            marginBottom: 34,
            animation: "fadeUp 0.9s ease forwards",
          }}
        >
          EVO-LIVE met en place des outils de protection avancés pour garantir
          un environnement sain, sécurisé et respectueux pour tous les utilisateurs.
        </p>

        {/* CARTES */}
        <div
          style={{
            width: "100%",
            maxWidth: 980,
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
            gap: 16,
            animation: "fadeUp 1.1s ease forwards",
          }}
        >
          {[
             ["🚫", "Anti-spam", "Détection automatique des comportements suspects.", "/anti-spam-demo"],
             ["🛡️", "Modération active", "Signalement et contrôle des contenus en temps réel.", "/moderation-demo"],
             ["🔐", "Protection des données", "Respect de la vie privée et des informations utilisateurs.", "/data-protection-demo"],
             ["⚖️", "Règles communautaires", "Un cadre clair pour une plateforme saine.", "/community-rules-demo"],
            ].map(([icon, title, text, route]) => (
            <div
              key={title}
              style={{
                padding: 24,
                borderRadius: 24,
                background: "rgba(0, 12, 20, 0.82)",
                border: "1px solid rgba(0,242,255,0.28)",
                boxShadow: "0 0 25px rgba(0,242,255,0.10)",
              }}
            >
              <div style={{ fontSize: 34, marginBottom: 12 }}>{icon}</div>

              <h3
                style={{
                  margin: "0 0 10px",
                  color: "#fff",
                  fontSize: 19,
                  fontWeight: 900,
                }}
              >
                {title}
              </h3>

              <p
                style={{
                  margin: 0,
                  color: "#9befff",
                  fontSize: 15,
                  lineHeight: 1.5,
                }}
              >
                {text}
              </p>
              <button
  onClick={() => navigate(route)}
  style={{
    marginTop: 16,
    border: "none",
    background: "linear-gradient(90deg, #00f2ff, #009dff)",
    color: "#001018",
    padding: "10px 18px",
    borderRadius: 14,
    fontSize: 13,
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 0 18px rgba(0,242,255,0.45)",
  }}
>
  Voir la démo →
</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SecurityShowPage;
